export enum LiveRecordingKeys {
    AudioLengthSeconds = "AudioLengthSeconds",
    AudioChunksReceived = "AudioChunksReceived",
    SuccessfullyEnded = "SuccessfullyEnded",
    FailureReason = "FailureReason",
    ServiceInitializationDuration = "ServiceInitializationDuration",
    InitializationTotalDuration = "InitializationTotalDuration",
    TranscriptionLocale = "TranscriptionLocale",
    IsAudioBackupEnabled = "IsAudioBackupEnabled",
    isMicrophonePermissionRetryDialogEnabled = "isMicrophonePermissionRetryDialogEnabled"
};